module.exports = __webpack_public_path__ + "media/categories/4010-73f65133.svg";